import PatientList from "../component/dashboard_general/PatientList"
import { useNavigate } from "react-router-dom"
import {
    NAVIGATION_VIEW,
    NavigationPaths
} from "../navigation/NavigationController"
import { useEffect } from "react"
import { useAppDispatch } from "../redux/store/hooks"
import {
    selectDashboardPatient,
    selectDashboardValueType
} from "../redux/ProfessionalDashboard"
import DashboardWrapper from "../component/DashboardWrapper"
import LinkingRequestsList from "../component/dashboard_general/LinkingRequestsList"
import OneTimePasswortInfo from "../component/dashboard_general/OneTimePasswortInfo"
import PsychoEducationBox from "../component/PsychoEducationBox"

function PatientSelectionView() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()

    useEffect(() => {
        dispatch(selectDashboardPatient(null))
        dispatch(selectDashboardValueType(null))
    }, [])

    function onSelect() {
        navigate(NavigationPaths[NAVIGATION_VIEW.PATIENT_OVERVIEW].path)
    }

    return (
        <DashboardWrapper>
            <div className={"flex flex-col space-y-4"}>
                <PatientList onSelect={onSelect} />
                <div className={"flex space-x-4"}>
                    <div className={"flex-1"}>
                        <OneTimePasswortInfo />
                    </div>
                    <div className={"flex-1 flex flex-col"}>
                        <LinkingRequestsList />
                    </div>
                </div>
                <PsychoEducationBox />
            </div>
        </DashboardWrapper>
    )
}

export default PatientSelectionView
